import { workflowVinMileageWithHistory, workflowVinMileageWithoutHistory, workflowYmmMileage } from '../components/super-component/navigation/step/steps';
import { ScrollMilestones } from '../interfaces/interface.offer';
import { sendTrackingEvent } from '../services/service.tracking';
import { state as answerState } from '../store/store.answers';
import { state as cobrandingState } from '../store/store.cobranding';
import { state as dealerState } from '../store/store.dealer';
import { state as funnelComponentState } from '../store/store.funnel-component';
import { state as vehicleConditionsState } from '../store/store.vehicle-conditions';
import { trackBackButton, trackNextButton, trackSubmitButton } from '../tracking/tracking.conditions';
import { trackUserScroll } from '../tracking/tracking.offer';
import { ErrorUtils } from '../utils/util.errors';
import { ANSWER_LEAD_TYPE_CASH_OFFER, ANSWER_LEAD_TYPE_OPT_OUT } from '../utils/utils.answers';
import { getRandomGuid, getTaggingEvent } from '../utils/utils.funnel-component';

export const onSuperComponentInit = (customId) => {
  funnelComponentState.isSuperComponent = true;
  funnelComponentState.customId = customId;
};

export const onVehicleInit = (offerCode, lnxCode, landingType, dealerId) => {
  const derivedDealerId = dealerId || cobrandingState.dealerId || dealerState.dealerId;
  const vehicle = {
    ...funnelComponentState.vehicle,
    ipAddress: '127.0.0.1',
    browserType: navigator.userAgent,
    referrerUrl: document.referrer || document.location.toString(),
    offerCode,
    lnxCode,
    landingType,
    dealerId: derivedDealerId,
    imageGroupGuid: getRandomGuid(),
    isVehicleCongfigValid: false,
    category: 'ico-super-component',
    answerValueForLeadTypeNo: derivedDealerId && derivedDealerId != 'null' ? ANSWER_LEAD_TYPE_OPT_OUT : ANSWER_LEAD_TYPE_CASH_OFFER,
  };

  funnelComponentState.vehicle = vehicle;
};

export const onThemeInit = (theme) => {
  funnelComponentState.theme = theme;
};

export const onFetchCobrandingDealerInfoSuccess = () => {
  const vehicle = {
    ...funnelComponentState.vehicle,
    dealerId: cobrandingState.dealerId || dealerState.dealerId,
    dealerGuid: cobrandingState.dealerGuid,
    dealerName: cobrandingState.dealerName,
    cobrandingGroupId: cobrandingState.cobrandingGroupId,
    acceptsReplacementVehicleAnswers: cobrandingState.acceptsReplacementVehicleAnswers,
    replacementVehicleOptions: {
      replacementVehicleMakes: cobrandingState.replacementVehicleMakes as number[],
      replacementVehicleModels: cobrandingState.replacementVehicleModels as number[],
      replacementVehicleTypes: cobrandingState.replacementVehicleTypes as string[],
    },
    answerValueForLeadTypeNo: cobrandingState.dealerGuid ? ANSWER_LEAD_TYPE_OPT_OUT : ANSWER_LEAD_TYPE_CASH_OFFER,
    requiresAllPhotos: cobrandingState.isRequirePhoto,
  };

  funnelComponentState.vehicle = vehicle;
};

export const onFetchAssignedDealerInfoSuccess = () => {
  const vehicle = {
    ...funnelComponentState.vehicle,
    dealerName: dealerState.name,
    dealerGuid: dealerState.dealerGuid,
    acceptsReplacementVehicleAnswers: cobrandingState.acceptsReplacementVehicleAnswers && dealerState.acceptsReplacementVehicleAnswers,
  };

  funnelComponentState.vehicle = vehicle;
};

export const onFormValidated = (result) => {
  let { isValid, form } = result;

  if (form === 'vehicle-config-form') {
    funnelComponentState.vehicle.isVehicleCongfigValid = isValid;
    if (isValid && !funnelComponentState.validation['keys-modifications-form']) {
      // If vehicle config is valid but keys-modifications isn't validated yet, show loading spinner
      funnelComponentState.isLoading = true;
      funnelComponentState.isTwoKeysLoading = true;
    } else if (!isValid) {
      // If vehicle config is invalid, also mark keys-modifications as invalid
      funnelComponentState.validation = {
        ...funnelComponentState.validation,
        'keys-modifications-form': false,
      };
    }
    isValid = false;
  }

  if (form === 'keys-modifications-form' && isValid && funnelComponentState.vehicle.isVehicleCongfigValid) {
    funnelComponentState.validation = { ...funnelComponentState.validation, [form]: isValid };
    form = 'vehicle-config-form';
  }

  if (form === 'vehicle-history-form' && isValid && !funnelComponentState.isYmmOffer && funnelComponentState.isAutoCheckAvailable) {
    // If we have autocheck data and the offer is not YMM, we should hide vehicle history from the breadcrumb
    funnelComponentState.steps = workflowVinMileageWithoutHistory();
  }

  funnelComponentState.validation = { ...funnelComponentState.validation, [form]: isValid };
};

export const onOfferSubmitStart = () => {
  funnelComponentState.isOfferSubmitting = true;
};

export const onOfferSubmitted = ({ emittedResponse: { offerId } }: { emittedResponse: { offerId: string } }) => {
  funnelComponentState.offerId = offerId;
  funnelComponentState.isLoading = true;
  funnelComponentState.currentStep++;
  funnelComponentState.isOfferSubmitting = false;
  funnelComponentState.submitOffer = false;
};

export const onOfferLoadComplete = () => {
  setTimeout(() => {
    funnelComponentState.isLoading = false;
  }, 200);
};

export const onOfferError = ({ errors }) => {
  funnelComponentState.isLoading = false;
  funnelComponentState.isOfferSubmitting = false;
  funnelComponentState.submitOffer = false;

  funnelComponentState.vehicle = {
    ...funnelComponentState.vehicle,
    offerSubmitErrorMessages: ErrorUtils.translateError(errors, funnelComponentState.theme),
  };

  const taggingEvent = getTaggingEvent(errors[0]);
  if (taggingEvent) {
    sendTrackingEvent({
      event: 'analytics_event',
      eventAction: 'impression',
      eventResult: taggingEvent,
      eventNonInteractive: false,
    });
  }

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'submit::ico::get-my-offer-error',
    eventNonInteractive: false,
  });
};

export const onOfferInProgress = (e) => {
  funnelComponentState.isLoading = false;
  funnelComponentState.isOfferSubmitting = false;
  funnelComponentState.submitOffer = false;
  funnelComponentState.prospectId = e.prospectId;
  funnelComponentState.currentStep++;
};

export const onLandingNextClick = (eventData) => {
  funnelComponentState.vehicle.allowAutoAnswer = !funnelComponentState.isYmmOffer;
  if (funnelComponentState.vehicle.trimId && funnelComponentState.vehicle.trimId !== eventData.trimId) {
    // If trim entered is different than what we have, reset the breadcrumb
    funnelComponentState.steps = funnelComponentState.isYmmOffer ? workflowYmmMileage() : workflowVinMileageWithHistory();
    Object.keys(funnelComponentState.showFormValidation).forEach((validatedStep) => {
      if (funnelComponentState.steps[validatedStep].isValidated) {
        funnelComponentState.steps[validatedStep].isValidated = false;
      }
    });
    // reset imageGroupGuid
    eventData.imageGroupGuid = getRandomGuid();
  }
  onVehicleData({ ...funnelComponentState.vehicle, ...eventData });
  onNextStep();
};

const onVehicleData = (vehicleData) => {
  funnelComponentState.vehicle = vehicleData;
};

export const onPreviousStep = () => {
  trackBackButton();
  funnelComponentState.isLoading = true;
  funnelComponentState.currentStep = Math.max(0, funnelComponentState.currentStep - 1);
};

export const onNextStep = () => {
  const step = funnelComponentState.steps[funnelComponentState.currentStep];
  const isValid = !step.validate || funnelComponentState.validation[step?.name];

  funnelComponentState.showFormValidation = [...funnelComponentState.showFormValidation];
  funnelComponentState.showFormValidation[funnelComponentState.currentStep] = true;

  if (isValid) {
    if (step.submit) {
      funnelComponentState.submitOffer = true;
      funnelComponentState.contactInfo = answerState?.contactInfo;
      trackSubmitButton();
    } else {
      if (vehicleConditionsState.isConditionPerfect && step?.name === 'vehicle-conditions') {
        trackNextButton(step.name);
        funnelComponentState.showYesItsPerfect = true;
        return;
      }
      trackNextButton(step.name);
      if (step.name === 'landing') {
        // To make sure event of mileage next button click on dynamic entry has page.hierarchy = "landing" , not "vehicle details"
        setTimeout(onIncreaseStep, 0);
      } else {
        onIncreaseStep();
      }
    }
  }
};

export const onNavigateToPage = (pageDetails) => {
  funnelComponentState.currentStep = pageDetails.index;
  funnelComponentState.isLoading = true;
};

export const onComponentHasLoaded = (location) => {
  if (
    (funnelComponentState.steps[funnelComponentState.currentStep]?.name != 'offer-certificate' && funnelComponentState.isTwoKeysLoading == false) ||
    location == 'vehicle-keys-modifications'
  ) {
    funnelComponentState.isLoading = false;
    funnelComponentState.isTwoKeysLoading = false;
  }
};

const onIncreaseStep = () => {
  funnelComponentState.isLoading = true;
  funnelComponentState.steps[funnelComponentState.currentStep].isValidated = true;
  funnelComponentState.currentStep = Math.min(funnelComponentState.steps.length - 1, funnelComponentState.currentStep + 1);
};

export const onYesItsPerfectModalClosed = () => {
  funnelComponentState.showYesItsPerfect = false;
};

export const onYesItsPerfectSelected = () => {
  onIncreaseStep();
};

export const setYmmSteps = () => {
  funnelComponentState.steps = workflowYmmMileage();
  funnelComponentState.isYmmOffer = true;
  funnelComponentState.vehicle.allowAutoAnswer = false;
};
export const setVinOrPlateOffer = () => {
  funnelComponentState.isYmmOffer = false;
};
export const setAutoCheckApiFailure = () => {
  funnelComponentState.isAutoCheckAvailable = false;
};

export const handleComponentScroll = (el: HTMLElement, scrollMilestones: ScrollMilestones = {}, setScrollMilestones?: (newMilestones: ScrollMilestones) => void) => {
  if (!el || !el.offsetHeight) {
    return scrollMilestones;
  }

  const componentHeight = el.offsetHeight;
  const componentTop = el.getBoundingClientRect().top;
  const viewportHeight = window.innerHeight;
  const scrollPercent = (Math.abs(componentTop) / (componentHeight - viewportHeight)) * 100;

  const newMilestones = { ...scrollMilestones };
  let hasUpdates = false;

  const milestones = [25, 50, 75, 100];

  milestones.forEach((milestone) => {
    if (scrollPercent >= milestone && !scrollMilestones[milestone]) {
      newMilestones[milestone] = true;
      trackUserScroll(milestone.toString());
      hasUpdates = true;
    }
  });

  // Update state if there are changes and a setter is provided
  if (hasUpdates && setScrollMilestones) {
    setScrollMilestones(newMilestones);
  }

  return newMilestones;
};

export default {
  onVehicleInit,
  onFetchDealerInfoSuccess: onFetchCobrandingDealerInfoSuccess,
  onFormValidated,
  onOfferSubmitStart,
  onOfferSubmitted,
  onOfferLoadComplete,
  onOfferError,
  onLandingNextClick,
  onPreviousStep,
  onNextStep,
  onNavigateToPage,
  onComponentHasLoaded,
  onYesItsPerfectModalClosed,
  onYesItsPerfectSelected,
  setVinOrPlateOffer,
  setYmmSteps,
  setAutoCheckApiFailure,
  onFetchAssignedDealerInfoSuccess,
  handleComponentScroll,
};
